






































import {Component, Prop, Vue} from "vue-property-decorator";
import {IMenuBaseEntity} from "@/model/menu/IMenuBaseEntity";
import {start} from "single-spa";

@Component
export default class SubMenuEntity extends Vue {
    @Prop() menu!: IMenuBaseEntity;
    @Prop({ default: true }) allowSubMenus!: boolean;

    isSubMenuRouteActive(eachMenu: IMenuBaseEntity): boolean {
        if ( !eachMenu.subMenus || eachMenu.subMenus.length === 0 ) return false;

        return eachMenu.subMenus && eachMenu.subMenus.some( (menu) => {
            if ( menu.name === this.$route.name )
                return true;

            return this.isSubMenuRouteActive(menu);
        } );
    }

    isMenuHasSubMenus(menuItem: IMenuBaseEntity): boolean {
        return menuItem.subMenus && menuItem.subMenus.some( (menu) => {
            return menu.subMenus && menu.subMenus.length > 0;
        } );
    }

    isMenuHasSubMenu(menuItem: IMenuBaseEntity): boolean {
        return menuItem.subMenus && menuItem.subMenus.length > 0;
    }

    isMenuHasPerColumn(menuItem: IMenuBaseEntity): boolean {
        return !!menuItem.perColumn && menuItem.perColumn > 0;
    }

    isMenuOpensLeft(menuItem: IMenuBaseEntity): boolean {
        return menuItem.subMenusDirection === 'left';
    }

    getFirstSubMenu(menuItem: IMenuBaseEntity): string {
        return menuItem.subMenus[0].path;
    }

    toFirstSubMenu(menuItem: IMenuBaseEntity) {
        this.$router.push(menuItem.subMenus[0].path);
    }
}
